import React, { createContext, useContext, useState, useCallback } from 'react';
import { isEqual, isFunction } from 'lodash';
import { UIHelpers } from '../../../../constants/pages/UIHelpers';

const FraudPreventionUIContext = createContext();
const { initialFilter } = UIHelpers();

export function useFraudPreventionUIContext () {
    return useContext(FraudPreventionUIContext);
}

export const FraudPreventionUIConsumer = FraudPreventionUIContext.Consumer;

export function FraudPreventionUIProvider ({ FraudPreventionUIEvents, children }) {
    const [isLoading, setIsLoading] = useState(false);
    const [queryParams, setQueryParamsBase] = useState(initialFilter);
    const [rulesList, setRulesList] = useState([]);
    const setQueryParams = useCallback(nextQueryParams => {
        setQueryParamsBase(prevQueryParams => {
            if (isFunction(nextQueryParams)) {
                nextQueryParams = nextQueryParams(prevQueryParams);
            }

            if (isEqual(prevQueryParams, nextQueryParams)) {
                return prevQueryParams;
            }

            return nextQueryParams;
        });
    }, []);

    const value = {
        isLoading,
        setIsLoading,
        queryParams,
        setQueryParamsBase,
        setQueryParams,
        rulesList,
        setRulesList
    };

    return <FraudPreventionUIContext.Provider value={value}>{children}</FraudPreventionUIContext.Provider>;
}
